import { ReactElement } from 'react';
import { StyledCircle, StyledTile } from '../styles';

type DataTileProps = {
  active?: boolean;
  value: number;
  label: string;
  name: string;
  onClick: () => void;
};

const DataTile = ({
  active,
  value,
  label,
  name,
  onClick,
}: DataTileProps): ReactElement => {
  return (
    <StyledTile
      data-testid={`healthcheck-dashboard-datatile-${name}`}
      onClick={onClick}
      aria-selected={active}
    >
      <StyledCircle aria-selected={active}>{value}</StyledCircle>
      {label}
    </StyledTile>
  );
};

export default DataTile;
